export const pluginId = 'cancellation-fee';
export const pluginName = 'Layaway cancellation fee';
export const cancellationFeePaymentInfo =
  'Plugin: Layaway cancellation fee payment';
